import { connect } from 'react-redux';
import { MinN } from '../../components/reporting/MinN';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/ReportingSetupStore';

export const MinNContainer = connect(
	(state: IApplicationState, props: { readOnly: boolean }) => ({
		...props,
		...state.reportingSetup.reportingSetupModel,
		isValid: true,
	}),
	{
		MinNChange: ActionCreators.MinNChange,
	},
)(MinN);
